<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2 form-horizontal">
  <div class="form-group row">
    <div class="col-md-12 col-12">
      <yt-dropdown-picklist [ModelName]="'podvrstadokumentastavka'" [GetName]="'GetByUrl'"
        [ModelProperty]="'Sifra,Naziv'" [GetParameters]="modelData.MainList.GetParameters"
        formControlName="PodVrstaDokumentaStavkaID"
        [Label]="'RESENJEZAPLACENOODSUSTVO.PODVRSTADOKUMENTASTAVKA.SINGULAR'" #autofocus
        [ngClass]="{'is-invalid': submitted && fc.PodVrstaDokumentaStavkaID.invalid}"
        (OnItemSelected)='onPodVrstaSelect()' [Width]="'600px'">
      </yt-dropdown-picklist>
      <div class="form-error" *ngIf="submitted && fc.PodVrstaDokumentaStavkaID.invalid">
        <span *ngFor="let validation of errorMessages.PodVrstaDokumentaStavkaID">
          <span class="error-message" *ngIf="fc.PodVrstaDokumentaStavkaID.hasError(validation.type)"><span
              translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
  </div>
  <div class="form-group row">
    <div class="col-md-6">
      <yt-fw-date-picker-popup name="dateDatum" formControlName="Datum"
        [ngClass]="{'is-invalid' : submitted && fc.Datum.invalid}" [Label]="'RESENJEZAPLACENOODSUSTVO.DATUM.SINGULAR'"
        (OnDateSelected)="onDatumChange($event)">
      </yt-fw-date-picker-popup>
      <div class="form-error" *ngIf="submitted && fc.Datum.invalid">
        <span *ngFor="let validation of errorMessages.Datum">
          <span class="error-message" *ngIf="fc.Datum.hasError(validation.type)"><span
              translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
    <div class="col-md-6 col-12">
      <div class="form-group row">
        <div class="col-md-8 col-8">
          <yt-input [Type]="'text'" [Label]="'RESENJEZAPLACENOODSUSTVO.BROJDOKUMENTA.SINGULAR'"
            formControlName="BrojDokumenta" [ngClass]="{'is-invalid': submitted && fc.BrojDokumenta.invalid}">
          </yt-input>
          <div class="form-error" *ngIf="submitted && fc.BrojDokumenta.invalid">
            <span *ngFor="let validation of errorMessages.BrojDokumenta">
              <span class="error-message" *ngIf="fc.BrojDokumenta.hasError(validation.type)"><span
                  translate="{{validation.message}}"></span></span>
            </span>
          </div>
        </div>
        <div class="col-md-4 col-4">
          <div class="input-group-append">
            <span class="span-control">/</span><span *ngIf="baseFormGroup.get('Datum').value != null"
              class="span-control">{{baseFormGroup.get('Datum').value.year}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="form-group row">
    <div class="col-md-12">
      <yt-dropdown-picklist [ModelName]="'zaposleni'" [GetName]="'get'" [ModelProperty]="'Prezime,Ime'"
        [GetParameters]="modelData.MainList.GetParameters" formControlName="OsobaID"
        [Label]="'RESENJEZAPLACENOODSUSTVO.OSOBA.SINGULAR'" [ngClass]="{'is-invalid': submitted && fc.OsobaID.invalid}">
      </yt-dropdown-picklist>
      <div class="form-error" *ngIf="submitted && fc.OsobaID.invalid">
        <span *ngFor="let validation of errorMessages.OsobaID">
          <span class="error-message" *ngIf="fc.OsobaID.hasError(validation.type)">
            <span translate="{{validation.message}}"></span>
          </span>
        </span>
      </div>
    </div>
  </div>
  <div class="form-group row">
    <div class="col-md-6">
      <yt-fw-date-picker-popup name="dateDatumZahteva" formControlName="DatumZahteva"
        [ngClass]="{'is-invalid' : submitted && fc.DatumZahteva.invalid}"
        [Label]="'RESENJEZAPLACENOODSUSTVO.DATUMZAHTEVA.SINGULAR'">
      </yt-fw-date-picker-popup>
      <div class="form-error" *ngIf="submitted && fc.DatumZahteva.invalid">
        <span *ngFor="let validation of errorMessages.DatumZahteva">
          <span class="error-message" *ngIf="fc.DatumZahteva.hasError(validation.type)"><span
              translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
    <div class="col-md-6">
      <yt-dropdown-picklist [ModelName]="'osnovzaplacenoodsustvo'" [GetName]="'get'"
        [ModelProperty]="'Naziv,min_broj_dana'" [GetParameters]="modelData.MainList.GetParameters"
        formControlName="OsnovID" [Label]="'RESENJEZAPLACENOODSUSTVO.OSNOV.SINGULAR'"
        [ngClass]="{'is-invalid': submitted && fc.OsnovID.invalid}">
      </yt-dropdown-picklist>
      <div class="form-error" *ngIf="submitted && fc.OsobaID.invalid">
        <span *ngFor="let validation of errorMessages.OsnovID">
          <span class="error-message" *ngIf="fc.OsnovID.hasError(validation.type)">
            <span translate="{{validation.message}}"></span>
          </span>
        </span>
      </div>
    </div>
  </div>



  <div class="form-group row">
    <div class="col-md-12">
      <yt-fw-date-range-picker-popup name="periodOdsustva" [Label]="'RESENJEZAPLACENOODSUSTVO.ODDATUMA.SINGULAR'"
        [LabelTo]="'RESENJEZAPLACENOODSUSTVO.DODATUMA.SINGULAR'" formControlName="Period"
        (OnDateSelected)="onDatumChange($event)" [MinDate]={year:2000,month:1,day:1}>
      </yt-fw-date-range-picker-popup>
    </div>
  </div>


  <div class="form-group row">
    <div class="col-md-6">
      <yt-input
        [Type]="'NUMERIC'"
        name="numberDana"
        formControlName="Dana"
        #focusElement
        [MaxLength]="2"
        [ngClass]="{'is-invalid': submitted && fc.Dana.invalid}"
        [Label]="'RESENJEZAPLACENOODSUSTVO.DANA.SINGULAR'"
      >
      </yt-input>
      <div class="form-error" *ngIf="submitted && fc.Dana.invalid">
        <span *ngFor="let validation of errorMessages.Dana">
          <span class="error-message" *ngIf="fc.Dana.hasError(validation.type)"><span
              translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
    <div class="col-md-6">
      <yt-fw-date-picker-popup name="dateDatumPocetkaRada" formControlName="DatumPocetkaRada"
        [ngClass]="{'is-invalid' : submitted && fc.DatumPocetkaRada.invalid}"
        [Label]="'RESENJEZAPLACENOODSUSTVO.DATUMPOCETKARADA.SINGULAR'">
      </yt-fw-date-picker-popup>
      <div class="form-error" *ngIf="submitted && fc.DatumPocetkaRada.invalid">
        <span *ngFor="let validation of errorMessages.DatumPocetkaRada">
          <span class="error-message" *ngIf="fc.DatumPocetkaRada.hasError(validation.type)"><span
              translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-md-12">
      <yt-text-area name="txtNapomena" [MaxLength]="500" formControlName="Napomena"
        [Label]="'RESENJEZAPLACENOODSUSTVO.NAPOMENA.SINGULAR'">
      </yt-text-area>
    </div>
  </div>
</form>